import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { SpinnerLoader } from 'shared/ui'
import { ContactsDetails } from 'widgets/ContactsDetails'
import { ChatbotDetailsProvider } from 'pages/chatbot/context'
import { useChatbotAnalyticContext } from 'pages/chatbot/pages/chatbotAnalytic/context/chatbotAnalyticContext'

import { ChatbotAnalyticSearch } from 'pages/chatbot/pages/chatbotAnalytic/ui/ChatbotAnalyticSearch'
import { ChatbotAnalyticCalendar } from 'pages/chatbot/pages/chatbotAnalytic/ui/ChatbotAnalyticCalendar'
import { ChatbotAnalyticHeader } from './ChatbotAnalyticHeader'
import { ChatbotAnalyticFilter } from './ChatbotAnalyticFilter'
import { ChatbotAnalyticTable } from './ChatbotAnalyticTable'

const ChatbotAnalyticPageContent = observer(() => {
  const { list, details, loading } = useChatbotAnalyticContext()
  const { contactsDetailsStore } = list

  useEffect(() => {
    list.init()
    list.loadData()

    return () => {
      list.reset()
    }
  }, [])

  return (
    <>
      {loading ? (
        <SpinnerLoader ariaLabel={'ChatbotAnalyticPage'} />
      ) : (
        <>
          <ChatbotAnalyticHeader details={details} />
          <ChatbotAnalyticCalendar />
          <ChatbotAnalyticFilter list={list} details={details} />
          <ChatbotAnalyticSearch />
          <ChatbotAnalyticTable list={list} details={details} />
        </>
      )}
      {contactsDetailsStore && <ContactsDetails store={contactsDetailsStore} />}
    </>
  )
})

export const ChatbotAnalyticPage = () => (
  <ChatbotDetailsProvider>
    <ChatbotAnalyticPageContent />
  </ChatbotDetailsProvider>
)
